export default {"src":"/_next/static/media/AGNC.190ea9bb.svg","height":18,"width":18};